const reviews = [
  {
    name: "Jennifer L.",
    location: "Mendenhall Valley, Juneau AK",
    rating: 5,
    text: "Living in Juneau means getting to Seattle is a full travel ordeal — flight, ferry, the works. FPC let me handle everything by mail and my passport arrived in 7 days. Absolutely saved our Alaska cruise.",
  },
  {
    name: "Mark B.",
    location: "Douglas Island, Juneau AK",
    rating: 5,
    text: "My passport expired two weeks before a business trip to Vancouver. Fast Passport Center processed my renewal in 5 days flat. The daily updates from my agent made the whole thing stress-free.",
  },
  {
    name: "Tanya R.",
    location: "Auke Bay, Juneau AK",
    rating: 5,
    text: "We needed passports for our whole family for a cruise. Two adults and one child — FPC handled all three and got them back in eight days. No trip to Seattle, no stress. Highly recommend.",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Juneau Travelers Say
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from real Juneau residents who used Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(r.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 italic">&ldquo;{r.text}&rdquo;</p>
              <div>
                <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                <p className="text-gray-400 text-xs">{r.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}